import { useEffect, useState } from "react";
import { getTableConfig, saveTableConfig } from "../../../../components/ModularDataTable/utils/persistConfig";
import { FilterPluginspace, FilterPluginspaceDto, PluginSpace, TableParams } from "../types";
import { GET_ADM, POST, POST_ADM } from "../../../../services/api";
import Swal from "sweetalert2";

export function usePluginsSpace(persistPageKey_?: string, persistContextKey_?: string) {

    const persistPageKey = persistPageKey_ || 'swagger_permissions';
    const persistContextKey = persistContextKey_ || 'swagger_permissions_context';


    const [pluginSpaces, setPluginSpaces] = useState<PluginSpace[]>([])
    const [loading, setLoading] = useState(false)
    const [tableLoading, setTableLoading] = useState(false)

    // Carrega persistido
    const persisted = getTableConfig(persistPageKey, persistContextKey) || {};

    const [pagination, setPagination] = useState({
        page: persisted.pagination?.page || 1,
        pageSize: persisted.pagination?.pageSize || 10,
        total: 0,
        pageSizes: [10, 25, 50, 100],
    })
    const [sorting, setSorting] = useState({
        field: persisted.sorting?.field || 'id',
        direction: persisted.sorting?.direction || 'asc',
    })
    const [searchTerm, setSearchTerm] = useState(persisted.filters?.search || '')
    const [pluginspaceFilters, setPluginspaceFilters] = useState<FilterPluginspaceDto>(persisted.filters || {})


    // Sempre que filtros, paginação ou sorting mudarem, salva tudo junto
    useEffect(() => {
        saveTableConfig(persistPageKey, persistContextKey, {
            filters: pluginspaceFilters,
            pagination,
            sorting,
        })
    }, [pluginspaceFilters, pagination, sorting])

    const handlePaginationChange = (newPagination: any) => {
        setPagination(newPagination)
        getPluginSpaces({
            page: newPagination.page,
            pageSize: newPagination.pageSize,
            search: searchTerm,
            sorting: sorting.field ? sorting : undefined,
        })
    }

    const handleSortingChange = (newSorting: any) => {
        setSorting(newSorting)
        getPluginSpaces({
            page: pagination.page,
            pageSize: pagination.pageSize,
            search: searchTerm,
            sorting: newSorting,
        })
    }

    const handleDataChange = async (params: {
        page: number
        pageSize: number
        search: string
        sorting?: { field: string; direction: 'asc' | 'desc' }
        filters?: any
    }) => {
        setPagination((prev) => ({ ...prev, page: params.page, pageSize: params.pageSize }))
        if (params.sorting) setSorting(params.sorting)
        setSearchTerm(params.search)
        if (params.filters) setPluginspaceFilters(params.filters)
        await getPluginSpaces(params)
    }

    function translateFilter(data: FilterPluginspaceDto): FilterPluginspace {
        const status = (!data.status || data.status?.value === 2) ? undefined : data.status?.value === 1 ? true : false;
        const type = data.type?.value === 'all' ? undefined : data.type?.value

        return {
            type,
            status,
        };
    }

    async function getPluginSpaces(params?: TableParams) {
        try {
            setTableLoading(true)
            const currentPage = params?.page || pagination.page
            const currentPageSize = params?.pageSize || pagination.pageSize
            const currentSearch = params?.search || searchTerm
            const currentSorting = params?.sorting || sorting

            const query = `?field=${currentSorting.field}&order=${currentSorting.direction.toUpperCase()}&page=${currentPage - 1}&take=${currentPageSize}&search=${currentSearch}`


            const currentFilters = translateFilter(params?.filters ?? pluginspaceFilters)

            const request = await POST_ADM(`/pluginspace/filter_admin${query}`, currentFilters)

            if (!request.data) {
                console.warn('[getPluginSpaces] Nenhum dado retornado da API!')
            }
            const mappedPluginspace = request.data
            setPluginSpaces(mappedPluginspace)

            if (request.meta) {
                const paginagionInfo = {
                    total: request.meta.itemCount,
                    page: currentPage,
                    pageSize: currentPageSize,
                }
                setPagination((prev) => ({
                    ...prev,
                    ...paginagionInfo,
                }))
                console.log('[getProducts] Paginação atualizada:', paginagionInfo)
            }
            return mappedPluginspace

        } catch (error) {
            console.log('[getProducts] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar as pluginspaces',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }



    return {
        pluginSpaces,
        pagination,
        sorting,
        searchTerm,
        pluginspaceFilters,
        loading,
        tableLoading,
        getPluginSpaces,
        handleDataChange,
        handlePaginationChange,
        handleSortingChange,
        setLoading,
    }
}